import { DELETE, GET, POST } from '../common/common.service'
import endpointsFavoritesFuelStations from './endpoints'

export const FavoritesFuelStationsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsFavoritesFuelStations.LOAD(filter, sort, limit, skip)),
  addFavorite: async (body) => POST(endpointsFavoritesFuelStations.ADD, body),
  removeFavorite: async (id) =>
    DELETE(endpointsFavoritesFuelStations.REMOVE(id)),
}
